// extracted by mini-css-extract-plugin
export default {"mainContainer":"LayoutDashboardPage_mainContainer__f6mv1"};